import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { REPAIR_ITEM_OPTIONS } from '../../../../constants/repair-items';

export interface RepairOrderDialogData {
  selected?: string[];
}

@Component({
  selector: 'app-repair-order-dialog',
  template: `
    <h2 mat-dialog-title>WHAT NEEDS REPAIR?</h2>
    <mat-dialog-content>
      <p class="repair-dialog-message">
        Select every part of the frame that R&amp;G has agreed to inspect or repair.
      </p>
      <mat-checkbox
        *ngFor="let option of options"
        class="repair-dialog-checkbox"
        [checked]="selected[option]"
        (change)="selected[option] = $event.checked"
      >
        {{ option }}
      </mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">CANCEL</button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="!canConfirm"
        (click)="confirm()"
      >
        REPAIR
      </button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .repair-dialog-message {
        margin: 0 0 12px;
        font-size: 13px;
        line-height: 1.4;
      }
      .repair-dialog-checkbox {
        display: block;
        white-space: normal;
        margin: 4px 0;
      }
    `,
  ],
})
export class RepairOrderDialogComponent {
  options = REPAIR_ITEM_OPTIONS;
  selected: { [key: string]: boolean } = {};

  constructor(
    public dialogRef: MatDialogRef<RepairOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RepairOrderDialogData
  ) {
    (data?.selected || []).forEach((item) => {
      this.selected[item] = true;
    });
  }

  get canConfirm(): boolean {
    return this.options.some((option) => this.selected[option]);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  confirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.dialogRef.close(
      this.options.filter((option) => this.selected[option])
    );
  }
}
